export const EN = {
  feature: {
    auth: {
      login: "Log In",
      $login: {
        title: "Sign In To Your Account!",
      },
      forgot_password: "Forgot Password",
      $forgot_password: {
        title: "Forgot Password?",
        message:
          "Enter your email address below and we will send on the provided email a code to reset your password",
      },
      reset_password: "Reset Password",
      $reset_password: {
        message:
          "We have sent the confirmation code to <b>{email}</b>, provide your new password and confirm it another time in the field below",
        expires_in:
          "The confirmation code will expire in <b>{time}</b> seconds",
        code_expired: "Code Expired",
        code_expired_message:
          "Your confirmation code is expired. Send a new request again, please",
      },
      $update_password: {
        success_message: "Your password has been successfully updated",
        force_message: "Your password is expired. Please update your password",
        first_access: "This is your first login. Please update your password",
      },
      $recovery_user_password: {
        title: "Recovery Password",
        success_message:
          "The password recovery procedure has been successfully completed.\nThe user will receive an email with instructions for resetting their password.",
        error_message:
          "The password recovery procedure has failed.\nPlease try again.",
        message:
          "Send this user an email providing the instructions to reset his password.",
      },
      request_support: "Request Support",
      $request_support: {
        message: "Fill the form to request support",
        request_type: "Request Type",
        $request_type: {
          1: "I am not able to login",
          2: "The app does not work correctly",
          3: "I have a question on a functionality",
        },
        success_message:
          "The support request has been successfully sent.\nYou will receive a response as soon as possible.",
      },
      invitation: "Invitation",
      $invitation: {
        instructions: "Enter the email address of the new user and submit the form. The system will send an email with instructions to complete the registration process. The invitation will be valid for 48 hours from the time it is sent.",
        send_success_message:
          "The invitation has been successfully sent.\nThe user will receive an email with instructions for accepting the invitation.",
        accept_success_message:
          "The invitation has been successfully accepted.\nYou will receive an email with with your credentials.",
        pending_invitations:  "Pending Invitations",
        pending_invitations_message: "The table lists all pending invitations. Once an invitation link expires, a button to resend a new invitation will be displayed.",
        resend_invitation: "Resend Invitation",
        invitation_expires_date: "Invitation Expiration Date",
        email_address: "Email Address",
      },
      delete_account: "Delete Account",
      $delete_account: {
        disclaimer:
          "This is a sample disclaimer text. By proceeding, you agree that deleting your account will permanently remove all associated data. Make sure to back up any important information before continuing. This action cannot be undone.",
        alert_message:
          "Warning: Deleting your account is a permanent action. All your data and access will be lost. If you are unsure, please contact support before proceeding.",
        success_message:
          "Your account has been successfully deleted. All associated data has been permanently removed. Thank you for using our service.",
        process_pending_warning: "<strong>Warning: The patient {patient_full_name} has exercised the right to withdraw consent or requested account deletion.</strong><br>Please make sure to download the patient's data using the export function available in their profile. After the grace period, all data will be permanently deleted and no longer accessible."
      },
      $withdraw_consent: {
        alert_message:
          "Warning: Withdrawing your consent means we will no longer be able to process your personal data for the purposes you previously agreed to. Some features and services may no longer be available.",
        success_message:
          "Your consent has been successfully withdrawn. You can update your preferences anytime in your profile settings.",
      },
      $download_patient_data: {
        success_message:
          "The patient data has been successfully prepared and is ready for download. Please store it securely and ensure compliance with data protection regulations.",
      },
    },
    therapy: {
      name: "Therapy",
      active_therapies: "Active therapies | Active therapy | Active therapies",
      inactive_therapies:
        "Inactive therapies | Inactive therapy | Inactive therapies",
      prescription: "Prescription",
      intake: {
        $status: {
          0: "Waiting",
          1: "Taken",
          2: "Taken not in time",
          3: "Not taken",
        },
        taken: "Taken",
        taken_in_time: "Taken in time",
        taken_not_in_time: "Taken not in time",
        not_taken: "Not taken",
        expected: "Expected",
        total: "Total",
        subtotal: "Subtotal",
      },
      $trend_range: {
        day: "Day",
        week: "Week",
        month: "Month",
        year: "Year",
        $frequency: {
          day: "Daily",
          week: "Weekly",
          month: "Monthly",
          year: "Yearly",
        },
      },
      $range: {
        from: "From",
        to: "To",
      },
      no_data: "No data collected",
      no_therapy_scheduled_today: "No therapy scheduled today",
      no_therapy_scheduled: "No therapy scheduled",
      provide_therapy: "Add new Therapy",
      drug: "Drug",
      prn: "PRN",
      dose: "Dose",
      overall_adherence: "Overall Adherence",
      adherence: "Adherence",
      intakes_per_day:
        "{count} times per day | {count} time per day | {count} times per day",
      add_all_prn: "Add all PRN",
      show_prn: "View PRN",
      daily_calendar: "Daily calendar",
    },
    home: {
      welcome_message: "Good morning, {name}!",
      welcome_subtitle: "Welcome to the HCP portal",
      your_center: "Your Center",
      $stats: {
        center: "Center Stats",
        total_patients: "Total Patients",
        total_caregivers: "Total Caregivers",
        total_hcps: "Total HCPs",
        centers_count: "Total Centers",
        countries_count: "Countries involved",
        patients_invited_count: "Patients invited",
        cargivers_count: "Total Caregivers",
        patients_activated_count: "Patients activated",
        therapies_started_count: "Ongoing Therapies",
      },
    },
    lists: {
      result_total: "Showing <b>{count}</b>",
      result_counts: "Showing <b>{count}</b> out of <b>{total}</b>",
      result_count_range:
        "Showing <b>{start}</b> - <b>{end}</b> out of <b>{total}</b>",
      out_of: "out of",
    },
    surveys: {
      patient_surveys: "Surveys",
      history: "History",
      no_surveys: "No survey submitted",
      treshold: "Recommended threshold",
      set_priority: "Set priority",
      modal_message:
        "Once set, you will not be able to disable it until expiration.",
      typology: {
        table: "Table",
        list: "List",
      },
      not_available_answer: "N/A",
      PDI: {
        right_eye: "Right eye",
        left_eye: "Left eye",
      },
      frequency: "Frequency",
      $frequency: {
        D: "Daily",
        M: "Monthly",
        Y: "Yearly",
        O: "Once",
      },
      value_representation_type: "Value representation type",
      $value_representation_type: {
        integer: "Integer",
        percentage: "Percentage",
        other: "Other",
      },
      min_value: "Min value",
      max_value: "Max value",
      min_label: "Min label",
      max_label: "Max label",
      step_increment: "Step increment",
      key_recommendations:
        "Provide a unique key to identify the Survey (e.g. preliminary_survey)",
      is_notifiable: "Send notifications",
      default_frequency_days: "Notification frequency in days",
      default_notification_time: "Notification time",
      extra: "Extra (JSON format)",
      $steps: {
        key_recommendations:
          "Provide a unique key to identify the Step (e.g. pain_today)",
        add: "Add Step",
        save: "Save Step",
        delete: "Delete Step",
        discard_changes: "Discard Changes",
        type: "Type",
        $type: {
          R: "Radio",
          T: "Text",
          V: "Value",
          D: "Description",
          F: "Finalize",
          VSS: "Sentiment",
          VAS: "Visual Analogue Scale",
          PDI: "Point of interests",
          TS: "Time span",
        },
        raw: "Raw",
        editor: "Editor",
        drag_reorder: "Drag & Drop index to edit steps order",
      },
      display_in_chart: "Display in chart",
      chart_type: "Chart type",
      $chart_type: {
        line: "Line",
        bar: "Bar",
        body_map: "Body Map",
      },
      labels: {
        bar_y_label: "Number of answers given",
      },
      required: "Required",
      include_na_option: "Include /NA option",
      conditions: "Conditions",
      role: "Role",
    },
    roles: {
      type: "Type",
      $type: {
        A: "Admin",
        H: "HCP",
        C: "Caregiver",
        P: "Patient",
        I: "Internal",
      },
      roles_permissions: "Roles Permissions",
      centers_permissions: "Centers Permissions",
      $permissions: {
        index: "Index",
        show: "Show",
        store: "Store",
        update: "Update",
        destroy: "Destroy",
      },
      center_users_management: "Users management",
      zone: "Zone",
      remind_policies: {
        title: "Reminder policies",
        message:
          "Please remember to set the policies for the newly created role ({type}) to ensure proper access and compliance.",
      },
      journey_schemas: "Journey Schemas",
      remind_journey_schemas: {
        title: "Reminder journey schemas",
        message: "Assign journey schemas to this role to define the patient's experience based on their role.",
      },
    },
    contents: {
      $categories: {
        visible: "Visible",
        visibility: "Visibility",
        $visibility: {
          all: "Public",
          restricted: "Restricted",
          undefined: "",
        },
        visibility_checkbox_message:
          "Public categories will be visible by all patients",
        imageCover: "Cover",
      },
      blocks: "Blocks",
      $blocks: {
        add: "Add Block",
        save: "Save Block",
        delete: "Delete Block",
        discard_changes: "Discard Changes",
        type: "Type",
        $type: {
          text: "Text",
          image: "Image",
          video: "Video",
          html: "HTML",
        },
        raw: "Raw",
        editor: "Editor",
        drag_reorder: "Drag & Drop index to edit blocks order",
      },
      content_permissions: "Patient's contents",
      category: "Category",
      lang: "Language",
      $lang: {
        en: "English",
        it: "Italian",
        de: "German",
        fr: "French",
        es: "Spanish",
      },
    },
    consents: "Consents",
    $consents: {
      enabled_consents: "Associated consents",
      hcp_enabled_consents: "Associated consents with HCPs",
      role_enabled_consents: "Associated consents with role {role}",
      update: "We have updated our privacy notice.",
      update_message: "Please review and accept it to continue using the app.",
    },
    consent: {
      draft: "Draft",
      version_history: "Version History",
    },
    messages: "Messages",
    $messages: {
      send: "Send Message",
      select_patient_message: "Select a patient to send messages",
    },
    $events: {
      all_day: "All day",
    },
    $caregivers: {
      no_caregivers: "No caregivers assigned to this patient",
    },
    $extra_fields: {
      no_choices: "No options selected",
    },
  },
  page: {
    home: "Home",
    patients: "Patients",
    patient: "Patient",
    caregivers: "Caregivers",
    add_caregiver: "Add Caregiver",
    edit_caregiver: "Edit Caregiver",
    analytics: "Analytics",
    create_patient: "Create New Patient",
    edit_patient: "Edit Patient",
    system_users: "System Users",
    invite_user: "Invite User",
    create_user: "Create User",
    edit_user: "Edit User",
    users: "Users",
    user: "User",
    centers: "System Centers",
    create_center: "Create Center",
    edit_center: "Edit Center",
    center: "Center",
    profile: "Profile",
    update_password: "Update password",
    roles: "System Roles",
    create_role: "Create Role",
    edit_role: "Edit Role",
    content_library: "Content Library",
    contents: "Contents",
    content_categories: "Categories",
    create_content_category: "Create Content Category",
    edit_content_category: "Edit Content Category",
    create_content: "Create Content",
    edit_content: "Edit Content",
    consents: "Consents",
    consent: "Consent",
    create_consent: "Create Consent",
    edit_consent: "Edit Consent",
    consent_version: "Consent Version",
    messages: "Messages",
    surveys: "Surveys",
    create_survey: "Create Survey",
    edit_survey: "Edit Survey",
    edit: "Edit",
    create: "Create",
    therapy_trend: "Therapy Trend",
    request_support: "Request Support",
    invitation_form: "Registration Form",
    zones: "Zones",
    delete_account: "Delete account",
    policies: "Policies",
    create_edit_zone: "Create / Edit Zone",
    privacy_and_cookies: "Privacy and Cookie Policy",
    footer_link: {
      privacy_policy: "Privacy Notice",
      cookie_policy: "Cookie Policy",
      terms_of_use: "Terms of Use",
    }
  },
  cta: {
    ok: "Ok",
    login: "Log In Now",
    logout: "Logout",
    submit: "Submit",
    back_to_login: "Back to Log In",
    view: "View",
    view_data: "View data",
    hide_data: "Hide data",
    edit: "Edit",
    search: "Search",
    clear_filters: "Clear filters",
    delete: "Delete",
    $delete: {
      title: "Are you sure?",
      message: "This action can not be undone",
    },
    delete_patient: "Delete Patient",
    delete_user: "Delete User",
    delete_center: "Delete Center",
    delete_role: "Delete Role",
    delete_category: "Delete Category",
    delete_content: "Delete Content",
    delete_consent: "Delete Consent",
    delete_event: "Delete Event",
    delete_caregiver: "Delete Caregiver",
    delete_zone: "Delete Zone",
    confirm: "Confirm",
    continue: "Continue",
    discard: "Discard",
    stop: "Stop",
    $discard: {
      message: "All your progress will be lost",
    },
    save: "Save",
    save_patient: "Save Patient",
    save_user: "Save User",
    save_center: "Save Center",
    save_role: "Save Role",
    save_category: "Save Category",
    save_content: "Save Content",
    save_consent: "Save Consent",
    save_consent_version: "Save Version",
    save_caregiver: "Save Caregiver",
    save_zone: "Save Zone",
    create: "Create",
    create_patient: "Create Patient",
    create_user: "Create User",
    create_center: "Create Center",
    create_role: "Create New Role",
    create_content_category: "Create Category",
    create_content: "Create Content",
    create_consent: "Create Consent",
    create_consent_version: "Create Version",
    restore_consent_version: "Restore Version",
    publish_consent: "Publish Version",
    create_caregiver: "Create Caregiver",
    create_zone: "Create Zone",
    schedule_therapy: "Schedule Therapy",
    update_password: "Update password",
    show_all: "Show All",
    send: "Send",
    add: "Add",
    add_event: "Add Event",
    edit_event: "Edit Event",
    save_event: "Save Event",
    add_caregiver: "Add Caregiver",
    load_more: "Load More",
    next: "Next",
    recovery_password: "Recovery Password",
    create_survey: "Create Survey",
    save_survey: "Save Survey",
    delete_survey: "Delete Survey",
    invite_user: "Invite User",
    accept_invitation: "Accept Invitation",
    download_patient_data: "Download Patient Data",
    withdraw_consent: "Withdraw Consent",
  },
  form: {
    first_name: {
      label: "Name",
      placeholder: "e.g. Adam",
    },
    last_name: {
      label: "Surname",
      placeholder: "e.g. Smith",
    },
    gender: {
      label: "Gender",
      0: "Unknown",
      1: "Male",
      2: "Female",
      3: "Other",
      4: "Transexual",
      5: "Unknown",
    },
    birth_date: {
      label: "Birth Date",
      placeholder: "dd/mm/yyyy",
    },
    email: {
      label: "Email",
      placeholder: "e.g. adam127704{'@'}gmail.com",
    },
    otp: {
      label: "OTP Code",
      placeholder: "Type the OTP code sent to your email",
    },
    password: {
      label: "Password",
      placeholder: "Type your password",
    },
    password_confirmation: {
      label: "Confirm Password",
      placeholder: "Retype your password",
    },
    current_password: {
      label: "Current Password",
      placeholder: "Type your current password",
    },
    address: {
      label: "Address",
      placeholder: "Add address",
    },
    city: {
      label: "City",
      placeholder: "Add city",
    },
    region: {
      label: "Region",
      placeholder: "Add region",
    },
    zip_code: {
      label: "ZIP Code",
      placeholder: "Add ZIP code",
    },
    country: {
      label: "Country",
      placeholder: "Add country",
    },
    location: {
      label: "Location",
      placeholder: "Add location",
    },
    phone: {
      label: "Phone Number",
      placeholder: "e.g. +001 321 4567",
    },
    notes: {
      label: "Notes",
      placeholder: "Add additional notes here",
    },
    center_id: {
      label: "Center",
      placeholder: "Select a center",
    },
    add_caregiver: {
      label: "Add a caregiver",
    },
    section: {
      patient_information: "Patient's information",
      user_information: "User's information",
      anagraph: "Anagraph",
      credentials: "Credentials",
      contacts: "Contacts",
      caregiver_information: "Caregiver's information",
      extra: "Extra",
      personal_information: "Personal Information",
      department_information: "Department Information",
      location: "Location",
    },
    invite_user_instructions:
      "To activate your account, complete the fields below with the required information. Once finished, you will receive an email with your temporary password to access the platform.",
    created_at: {
      label: "Created At",
    },
    start_at: {
      label: "Start At",
    },
    end_at: {
      label: "End At",
      $error: {
        therapy_range_error: "Therapy must last at least {min} days",
      },
    },
    name: {
      label: "Name",
    },
    title: {
      label: "Title",
    },
    description: {
      label: "Description",
      placeholder: "Add a description",
    },
    website: {
      label: "Website",
    },
    role: {
      label: "Role",
    },
    role_in_department: {
      label: "Role in Department",
    },
    organization: {
      label: "Organization Name",
    },
    department: {
      label: "Department Name",
    },
    main_contractor: {
      label: "Primary Contact",
    },
    confirmation_code: {
      label: "Confirmation Code",
      placeholder: "Insert the confirmation code provided on your email",
    },
    active: {
      label: "Active",
    },
    value: {
      label: "Value",
    },
    subtitle: {
      label: "Subtitle",
    },
    url: {
      label: "URL",
    },
    revision_number: {
      label: "Revision Number",
      placeholder: "e.g. 1.2",
    },
    body: {
      label: "Body",
    },
    mandatory: {
      label: "Mandatory",
      placeholder:
        "Provide the message to be shown to users when they don't accept the mandatory consent",
    },
    has_checkbox: {
      label: "Checkbox for acknowledgment",
      placeholder: "Add the text of the checkbox label",
    },
    select_placeholder: "Select an option",
    select_file: "Select File",
    subject: {
      label: "Subject",
      placeholder: "Insert the subject",
    },
    message: {
      label: "Message",
      placeholder: "Insert your message",
    },
    type: {
      label: "Type",
    },
    date: {
      label: "Date",
    },
    key: {
      label: "Key",
    },
    footer: {
      label: "Footer",
    },
    assignment_strategy: {
      label: "Assignment Strategy",
      values: {
        by_hcp: "By HCP",
        by_center: "By Center",
        self_registration: "Self Registration",
      },
    },
    is_registration_enabled: {
      label: "Enable patient self-registration",
    }
  },
  error: {
    something_went_wrong: "Something went wrong!",
    connection_error:
      "The request was not sent or there was no response from the server.\nCheck your internet connection.",
  },
  footer_disclaimer: {
    kareena: "",
    sifi_fk: "All rights reserved - VAT number 00122890874",
    fungalk: "All rights reserved - VAT number 00122890874",
  },
  invitation_policies: {
    terms_of_use: 'I have read the <a href="{url}" target="_blank">Terms of Use</a> and hereby accept them.',
    privacy_policy: 'Details on how we process your personal data is described in our <a href="{url}" target="_blank">Privacy Notice</a>.',
    cookie_policy: '<a href="{url}" target="_blank">Cookie Policy</a>.',
  },
  footer_links: {
    terms_of_use: {
      kareena: "",
      sifi_fk: 'https://karomy.it/document/KAROMY_Dashboard_Terms_of_Use.pdf',
      fungalk: "https://sifi-visionpath-dashboard-stage.azurewebsites.net/downloads/Dashboard/VisionPath_Dashboard_Terms_of_Use.pdf",
    },
    privacy_policy: {
      kareena: "",
      sifi_fk: 'https://karomy.it/document/Karomy_Platform_Privacy_Notice_Dashboard_Physician.pdf',
      fungalk: "https://sifi-visionpath-dashboard-stage.azurewebsites.net/downloads/Dashboard/VisionPath_Platform_Privacy_Notice_Dashboard_Physician.pdf",
    },
    cookie_policy: {
      kareena: "",
      sifi_fk: 'https://karomy.it/document/KAROMY_Dashboard_Cookie_Policy_EN.pdf',
      fungalk: "",
    },
  },

  "France": 'France',
  "Italy": 'Italy',
  "Spain": 'Spain',
  "United Kingdom": 'United Kingdom',
  "Germany": 'Germany',
};
